import { createAcl, defineAclRules } from "vue-simple-acl";
import router from "@/router";
import { useLoginStore } from '@/stores/loginStore';
import useUserSession from '@/composables/useUserSession';

const {
    getRefreshToken,
    getIsAuthenticated,
    isAccessTokenExpired,
    isTwoFactorVerified
} = useUserSession();

const getUser = async () => {
    const loginStore = useLoginStore();
    if (getRefreshToken() === null || !isTwoFactorVerified()) {
        return {
            user: {},
        };
    }

    if (!getIsAuthenticated() || isAccessTokenExpired()) {
        await loginStore.refreshCredentials();
    } else {
        loginStore.startRefreshTokenTimer();
    }
    await loginStore.fetchMe();
    return loginStore.getMe;
}

const rules = () => defineAclRules((setRule) => {
    setRule('admin', (us) => us?.user?.is_admin === true);
});

const simpleAcl = createAcl({
    user: getUser,
    rules,
    router,
    onDeniedRoute: '/unauthorized',
});

export default simpleAcl;
